import type { TableAdminDTO } from '@six-pockets/shared';
import { formatINR } from '@/utils/format';
import { RowActions } from './RowActions';
import styles from '@/styles/components/TableManageRow/style.scss';

interface TableManageRowProps {
  table: TableAdminDTO;
  onEdit: () => void;
  onDelete: () => void;
}

/** One table on the Manage tables page. */
export function TableManageRow({ table, onEdit, onDelete }: TableManageRowProps) {
  return (
    <tr>
      <td className={styles.name}>{table.name}</td>
      <td className={styles.text}>{table.kind}</td>
      <td className={styles.money}>{formatINR(table.ratePerHour)}</td>
      <td className={styles.data}>{table.sortOrder}</td>
      <td>
        <RowActions
          name={table.name}
          onEdit={onEdit}
          onDelete={onDelete}
          deleteBlockedReason={table.inUse ? 'Has unbilled bookings or condiments; bill them first' : undefined}
        />
      </td>
    </tr>
  );
}
